export class LoadingConfig {
    enabled: boolean;

    constructor(config: Partial<LoadingConfig>) {
        this.enabled = config.enabled || true;
    }
}
